import { useEffect, useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { createUser } from '../../api/adminAPI';

interface UserRegisterModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const UserRegisterModal = ({ open, onClose, onSuccess }: UserRegisterModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    if (values.pw !== values.pwConfirm) {
      form.setFields([
        { name: 'pwConfirm', errors: ['비밀번호가 일치하지 않습니다.'] },
      ]);
      setLoading(false);
      return;
    }
    try {
      await createUser(values.id, values.pw, values.name); 
      message.success('성공적으로 등록되었습니다.');
      onSuccess();
      onClose();
    } catch (e) {
      if (e.response && e.response.status === 409) {
        form.setFields([
          {
            name: 'id',
            errors: ['이미 존재하는 아이디입니다. 다른 아이디를 사용해주세요.'],
          },
        ]);
      } else {
        message.error('유저 등록에 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  const blockSpace = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  return (
    <Modal
      title="신규 유저 등록"
      open={open}
      onOk={form.submit}
      onCancel={onClose}
      okText="등록"
      cancelText="취소"
      centered
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ marginTop: '20px' }}
      >
        <Form.Item
          label="아이디"
          name="id"
          rules={[
            { required: true, message: '아이디를 입력해주세요.' },
            { pattern: /^\S*$/, message: '공백 없이 입력해주세요.' }
          ]}
        >
          <Input placeholder="아이디를 입력하세요" onKeyDown={blockSpace} />
        </Form.Item>

        <Form.Item
          label="비밀번호"
          name="pw"
          rules={[
            { required: true, message: '비밀번호를 입력해주세요.' },
            { pattern: /^\S*$/, message: '공백 없이 입력해주세요.' }
        ]}
        >
          <Input.Password placeholder="비밀번호를 입력하세요" onKeyDown={blockSpace} />
        </Form.Item>

        <Form.Item
          label="비밀번호 확인"
          name="pwConfirm"
          rules={[{ required: true, message: '비밀번호 확인을 입력해주세요.' }]}
        >
          <Input.Password placeholder="비밀번호를 한 번 더 입력하세요" />
        </Form.Item>

        <Form.Item
          label="이름"
          name="name"
          rules={[
            { required: true, message: '이름을 입력해주세요.' },
            { whitespace: true, message: '공백만으로 이름을 입력할 수 없습니다.' }
          ]}
        >
          <Input placeholder="이름을 입력하세요" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserRegisterModal;